/* eslint-disable no-restricted-imports */
import { SendETH } from './actions/sendETH';
import { UnwrapETH } from './actions/unwrapETH';
import { WrapETH } from './actions/wrapETH';
import { GetETHBalance } from './getters/getETHBalance';
var actions = {
    WrapETH: WrapETH,
    UnwrapETH: UnwrapETH,
    SendETH: SendETH,
};
var getters = {
    GetETHBalance: GetETHBalance,
};
var Utility = {
    actions: actions,
    getters: getters,
};
export { Utility };
